export const environment = {
  appVersion: "1.0.1",
  production: true,
  url: 'https://www.jemigo.com',  
};
